module.exports = __webpack_public_path__ + "static/Proactive_Security_measures-1cf62f9357502bf03508ca278e75fae5.svg";